import React, { useEffect, useState } from 'react';
import {
  MdNavigateBefore,
  MdNavigateNext,
  MdSkipNext,
  MdSkipPrevious,
} from 'react-icons/md';

interface PaginationProps {
  take?: number;
  total: number;
}

export default function Pagination({ total, take = 5 }: PaginationProps) {
  const [atualPage, setAtualPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pages, setPages] = useState<number[]>([]);

  const buildPages = () => {
    const foo = atualPage + 6;
    const bar = atualPage - 6;
    const pagesArray = [];
    for (let i = atualPage; i <= totalPages; i += 1) {
      if (i < foo) pagesArray.push(i);
    }
    setPages(pagesArray);
  };

  const goToPage = (page: number) => {
    setAtualPage(page);
    buildPages();
  };

  const goToLastPage = () => {
    goToPage(totalPages);
  };

  const previousPage = () => {
    const previous = atualPage - 1;
    if (previous) goToPage(previous);
  };

  const nextPage = () => {
    const next = atualPage + 1;
    if (next <= totalPages) goToPage(next);
  };

  useEffect(() => {
    if (total && take) {
      setTotalPages(Math.round(total / take));
    }
  }, [total, take]);

  useEffect(() => {
    if (totalPages) {
      buildPages();
    }
  }, [totalPages]);

  return (
    <div
      className='bg-light border w-100 p-1 bottom-0 start-50 translate-middle-x'
      style={{ position: 'fixed' }}
    >
      <nav>
        <ul className='justify-content-center pagination m-0'>
          <li className='page-item'>
            <button
              className='btn page-link text-secondary'
              type='button'
              onClick={() => goToPage(1)}
            >
              <span aria-hidden='true'>
                <MdSkipPrevious />
              </span>
            </button>
          </li>
          <li className='page-item'>
            <button
              className='btn page-link text-secondary'
              type='button'
              onClick={() => previousPage()}
            >
              <span aria-hidden='true'>
                <MdNavigateBefore />
              </span>
            </button>
          </li>
          {pages.map((i) => {
            return (
              <li key={i} className='page-item'>
                <button
                  className={`btn page-link ${
                    i === atualPage
                      ? 'text-light bg-secondary'
                      : 'text-secondary'
                  }`}
                  type='button'
                  onClick={() => goToPage(i)}
                >
                  {i}
                </button>
              </li>
            );
          })}
          <li className='page-item'>
            <button
              className='btn page-link text-secondary'
              type='button'
              onClick={() => nextPage()}
            >
              <span aria-hidden='true'>
                <MdNavigateNext />
              </span>
            </button>
          </li>
          <li className='page-item'>
            <button
              className='btn page-link text-secondary'
              type='button'
              onClick={() => goToLastPage()}
            >
              <span aria-hidden='true'>
                <MdSkipNext />
              </span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
